import { Spin } from 'antd'
import React, { useState } from 'react'

import Icon from '@ui-pc/Icon'
import Switch from '@ui-pc/Switch'
import { Type } from '@utils/tool'
import { useReactive } from '@utils/tool/khook'

type Props = {
  onClick(isLike: boolean)
  liking: boolean
  children?: number
}

const Liked = (props: Props) => {
  const { onClick, children, liking } = props

  const [state, setState] = useReactive({
    liking: liking,
    children: Type.number(children),
    loading: false
  })

  React.useEffect(() => {
    setState({ children: Type.number(children) })
  }, [children])

  React.useEffect(() => {
    setState({ liking: liking })
  }, [liking])

  return (
    <Switch either={true}>
      <>
        <Spin indicator={null} spinning={state.loading}>
          <span
            //@ts-expect-error
            favorable={state.liking?.toString()}
            onClick={async () => {
              const isLike = !state.liking
              setState({ loading: true })
              await onClick(isLike).finally(() => {
                setState({ loading: false })
                // throw new Error()
              })
              const children = isLike ? state.children + 1 : state.children - 1
              setState({ loading: false, liking: isLike, children })
            }}>
            <Icon
              className="icon"
              customSrc={state.liking ? 'icon-zan2' : 'icon-zan'}
            />{' '}
            <span //@ts-expect-error
              favorable={state.liking?.toString()}>
              Helpful
            </span>{' '}
            {state.children > 0 && `(${state.children})`}
          </span>
        </Spin>
      </>
    </Switch>
  )
}

export default Liked
